import { NumberFormatter } from "@mantine/core";
import { RUBLE_SIGN } from "shared/const/common";

type Props = {
  value: number;
};
export const RubleNumberFormatter = ({ value }: Props) => (
  <NumberFormatter suffix={` ${RUBLE_SIGN}`} thousandSeparator={" "} value={value} />
);
